(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('MailingCampaignsController', mailingcampaign);

  mailingcampaign.$inject = ['$http', '$rootScope', 'FoundationApi', 'LangService', 'MailingCampaignService', 'ImportedFilesService', 'MailingTagService', 'CompanyService', 'NotificationFactory', 'Upload', '$timeout', '$stateParams', '$state', 'NotificationService', 'ngTableParams', 'WaentService'];

  function mailingcampaign ($http, $rootScope, FoundationApi, LangService, MailingCampaignService, ImportedFilesService, MailingTagService, CompanyService, NotificationFactory, Upload, $timeout, $stateParams, $state, NotificationService, ngTableParams, WaentService) {
    var vm = this;
    vm.labels = '';
    LangService
      .getPageLabels({ 'page': 'menu.config.mailing' })
      .$promise
      .then(function (data) {
        vm.labels = data.lang;
        vm.diasDaSemana = {
          1: vm.labels.sunday,
          2: vm.labels.monday,
          3: vm.labels.tuesday,
          4: vm.labels.wednesday,
          5: vm.labels.thursday,
          6: vm.labels.friday,
          7: vm.labels.saturday
        };
      });

    var notifSet = new NotificationFactory({
      position: 'bottom-right'
    });

    var fileConfigs;

    vm.enablePercent = false;
    vm.duplicating = false;
    vm.campaign = {
      active: 1,
      imported_files_id: 0,
      filters: {
        groups: [{
          filters: [{
            condition: '',
            imported_files_fields_id: '',
            test_condition: '',
            test_value: ''
          }],
          condition: ''
        }]
      },
      send_sms: false,
      send_email: false,
      send_waent_params: [{'percent': 100, 'time': '08:00'}],
      send_sms_params: [{'percent': 100, 'time': '08:00'}],
      send_week_days: {},
      send_params: [{}],
      types: {}
    };

    vm.openImportModal = openImportModal;
    vm.closeImportModal = closeImportModal;
    vm.addGroup = addGroup;
    vm.delGroup = delGroup;
    vm.addFilter = addFilter;
    vm.delFilter = delFilter;
    vm.addParam = addParam;
    vm.delParam = delParam;
    vm.addSMSParam = addSMSParam;
    vm.delSMSParam = delSMSParam;
    vm.addWaentParam = addWaentParam;
    vm.delWaentParam = delWaentParam;
    vm.confirmDelete = confirmDelete;
    vm.removeCampaign = removeCampaign;
    vm.save = save;
    vm.content = [];
    vm.confirmDuplicate = confirmDuplicate;
    vm.duplicateCampaign = duplicateCampaign;
    vm.goToTheListing = goToTheListing;
    vm.runCommand = runCommand;
    vm.processedFiles = [];
    vm.loadAllUploadedFiles = loadAllUploadedFiles;
    vm.filterSpecificCharacter = filterSpecificCharacter;
    vm.minimizeSpecificCharFilter = minimizeSpecificCharFilter;
    vm.filterParamSpecificCharacter = filterParamSpecificCharacter;
    vm.minimizeSpecificCharFilterParam = minimizeSpecificCharFilterParam;
    vm.changeCampaignType = changeCampaignType;
    vm.loadCampaignTypes = loadCampaignTypes;
    vm.loadFileConfigs = loadFileConfigs;
    vm.changeSendType = changeSendType;
    vm.chooseWaentChannel = chooseWaentChannel;
    vm.onCheckFaturas = onCheckFaturas;
    vm.setExpirationDate = setExpirationDate;
    vm.waentSubChannels = {}

    /**
     * @todo necessário deixar dinâmico os nomes dos dias da semana
     */
    vm.errors = {};

    loadCompanyData();
    loadAllUploadedFiles();
    loadCampaignTypes();

    if (typeof $stateParams.id !== 'undefined') {
      if (parseInt($stateParams.id) > 0) {
        loadCampaign();
      }
    } else {
      loadAllCampaigns();
    }

    vm.pikadayMinDate = moment().format('MM/DD/YYYY');

    function openImportModal () {
      vm.campaign.imported_files_id = 0;

      var date = vm.expirationDate = moment()._d;
      vm.pkadayExpirationDate.setMinDate(date);
      vm.expirationDate = moment().add(1, 'days').format('DD/MM/YYYY');

      FoundationApi.publish('importFileModal', 'open');
    }

    function closeImportModal () {
      FoundationApi.publish('importFileModal', 'close');
    }

    /**
     * FILTERS CONTROL
     */
    function addGroup () {
      var defaultGroup = {
        filters: [],
        condition: ''
      };

      vm.campaign.filters.groups.push(defaultGroup);

      var groupIndex = vm.campaign.filters.groups.length - 1;

      addFilter(groupIndex);
    }

    function delGroup (groupIndex) {
      if (typeof vm.campaign.filters.groups[groupIndex] !== 'undefined') {
        vm.campaign.filters.groups.splice(groupIndex, 1);
      }

      if (vm.campaign.filters.groups.length == 0) {
        addGroup();
      }
    }

    function addFilter (groupIndex) {
      var defaultFilter = {
        condition: '',
        imported_files_fields_id: '',
        test_condition: '',
        test_value: ''
      };

      vm.campaign.filters.groups[groupIndex].filters.push(defaultFilter);
    }

    function delFilter (groupIndex, filterIndex) {
      if (typeof vm.campaign.filters.groups[groupIndex].filters[filterIndex] !== 'undefined') {
        vm.campaign.filters.groups[groupIndex].filters.splice(filterIndex, 1);
      }

      if (vm.campaign.filters.groups[groupIndex].filters.length == 0) {
        addFilter(groupIndex);
      }
    }

    /**
     * SEND PARAMS CONTROL
     */
    function addParam (paramObj) {
      paramObj = paramObj || {}

      vm.campaign.send_params.push(paramObj);
    }

    function delParam (paramIndex) {
      if (typeof vm.campaign.send_params[paramIndex] !== 'undefined') {
        vm.campaign.send_params.splice(paramIndex, 1);
      }

      if (vm.campaign.send_params.length == 0) {
        addParam();
      }
    }

    /**
     * SMS PARAMS CONTROL
     */
    function addSMSParam (smsParamObj) {
      smsParamObj = smsParamObj || {}

      vm.campaign.send_sms_params.push(smsParamObj);
    }

    function delSMSParam (paramIndex) {
      if (typeof vm.campaign.send_sms_params[paramIndex] !== 'undefined') {
        vm.campaign.send_sms_params.splice(paramIndex, 1);
      }

      if (vm.campaign.send_sms_params.length == 0) {
        addSMSParam();
      }
    }

    /**
     * WAENT PARAMS CONTROL
     */
    function addWaentParam (waentParamObj) {
      waentParamObj = waentParamObj || {}

      vm.campaign.send_waent_params.push(waentParamObj);
    }

    function delWaentParam (paramIndex) {
      if (typeof vm.campaign.send_waent_params[paramIndex] !== 'undefined') {
        vm.campaign.send_waent_params.splice(paramIndex, 1);
      }

      if (vm.campaign.send_waent_params.length == 0) {
        addWaentParam();
      }
    }

    function confirmDelete (index) {
      vm.deleting = vm.campaigns.data[index];
      FoundationApi.publish('confirmDeleteModal', 'open');
    }

    function removeCampaign (campaign) {
      MailingCampaignService
        .delete({ id: campaign.id })
        .$promise
        .then(function (obj) {
          loadAllCampaigns();

          FoundationApi.publish('confirmDeleteModal', 'close');

          successHandler(obj, vm.labels.deletedCamp);

          goToTheListing();
        })
        .catch(function (error) {
          errorHandler(error, vm.labels.errorDeleteCamp);
        });
    }

    function confirmDuplicate () {
      vm.duplicating = true;
      FoundationApi.publish('confirmDuplicateModal', 'open');
    }

    function duplicateCampaign () {
      vm.campaign.id = void 0;
      save(false);
    }

    function goToTheDetail (detailId) {
      $state.go('main.edit-mailingcampaign', { id: detailId });
    }

    function goToTheListing () {
      $state.go('main.mailingcampaign', {});
    }

    function save (redirect) {
      redirect = redirect || true;

      if (!vm.campaign.imported_files_id) {
        NotificationService.warningHandler(null, vm.labels.selectCampType);
        return;
      }

      if (vm.campaign.send_sms) {
        var sum = 0;
        for (var i = 0; i < vm.campaign.send_sms_params.length; i++) {
          if (vm.campaign.send_sms_params[i].hasOwnProperty('percent')) {
            sum += vm.campaign.send_sms_params[i].percent;
          }
        }

        if (sum != 100) {
          NotificationService.warningHandler(null, vm.labels.wrongPercent);
          return;
        }
      }

      if (vm.campaign.send_waent) {
        var sum = 0;
        for (var i = 0; i < vm.campaign.send_waent_params.length; i++) {
          if (vm.campaign.send_waent_params[i].hasOwnProperty('percent')) {
            sum += vm.campaign.send_waent_params[i].percent;
          }

          let fullTime = vm.campaign.send_waent_params[i].time

          if (fullTime.length <= 4) {
            vm.campaign.send_waent_params[i].time = fullTime.substr(0,2) + ':' + fullTime.substr(-2,2)
          }

          let isValidHour = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(vm.campaign.send_waent_params[i].time);

          if (!vm.campaign.send_waent_params[i].time || !isValidHour) {
            NotificationService.warningHandler(null, vm.labels.invalidSentDate);
            return;
          }

          if (!vm.campaign.send_waent_params[i].percent) {
            NotificationService.warningHandler(null, vm.labels.wrongPercentWaent);
            return;
          }
        }

        if (sum != 100) {
          NotificationService.warningHandler(null, vm.labels.wrongPercentWaent);
          return;
        }
      }

      if (vm.campaign.hasOwnProperty('extra_params') && vm.campaign.extra_params) {
        if ((vm.campaign.extra_params.sector || vm.campaign.extra_params.noChatbot) && (vm.campaign.expiration_date == 'undefined' || !vm.campaign.expiration_date)) {
          NotificationService.warningHandler(null, vm.labels.expirationWaentValidation);
          return;
        }
      }

      if (typeof vm.campaign.id !== 'undefined' && parseInt(vm.campaign.id, 10) > 0) {
        MailingCampaignService
          .update(vm.campaign)
          .$promise
          .then(function (result) {
            successHandler(result, vm.labels.updatedCamp);

            if (redirect) {
              goToTheListing();
            }
          })
          .catch(function (result) {
            vm.errors = result.data.error_data;

            errorHandler(result, vm.labels.errorUpdateCamp);
          });
      } else {
        MailingCampaignService
          .create(vm.campaign)
          .$promise
          .then(function (result) {
            var message = vm.labels.saveCamp;

            if (vm.duplicating) {
              message = vm.labels.duplicateCampSuccess;
              redirect = false;
              vm.duplicating = false;

              FoundationApi.publish('confirmDuplicateModal', 'close');

              setTimeout(function () {
                FoundationApi.publish('confirmRedirectModal', 'open');
              }, 1000);

              goToTheDetail(result.data.id);
            }

            successHandler(result, message);

            if (redirect) {
              goToTheListing();
            }
          })
          .catch(function (result) {
            vm.errors = result.data.error_data;

            errorHandler(result, vm.labels.errorSaveCamp);
          });
      }
    }

    vm.maximizeMessageField = function (index) {
      if (typeof vm.campaign.send_params[index] !== 'undefined') {
        var row = vm.campaign.send_params[index];

        if (typeof row.message_email === 'undefined' || row.message_email.length == 0) {
          row.message_email = row.message;
        }

        FoundationApi.publish('textareaMsgModal_' + index, 'open');
      }
    }

    function parseMessageEmail () {
      if (typeof vm.campaign.send_params !== 'undefined') {
        var lengthParams = vm.campaign.send_params.length;

        for (var i = 0; i < lengthParams; i++) {
          parseRowMessageEmail(vm.campaign.send_params[i]);
        }
      }
    }

    function parseRowMessageEmail (row) {
      if (typeof row.message_email !== 'undefined') {
        var arrContent = row.message_email.split('\n');

        row.message = arrContent[0];

        if (row.message.length > 25 || arrContent.length > 1) {
          row.message = row.message.substr(0, 25) + ' ...';
        }
      }

      return row;
    }

    vm.minimizeMessageField = function (index, closeModal) {
      closeModal = closeModal || true;

      if (typeof vm.campaign.send_params[index] !== 'undefined') {
        vm.campaign.send_params[index] = parseRowMessageEmail(vm.campaign.send_params[index]);

        FoundationApi.publish('textareaMsgModal_' + index, 'close');
      }
    }

    vm.maximizeTags = function () {
      if (typeof vm.campaign.imported_files_id !== 'undefined') {
        FoundationApi.publish('tagsMsgModal', 'open');
      } else {
        errorHandler({}, vm.labels.fileFormat);
      }
    }

    vm.minimizeTags = function () {
      FoundationApi.publish('tagsMsgModal', 'close');
    }

    function loadAllCampaigns () {
      vm.campaignTable = new ngTableParams({
        page: 1,
        count: 25
      }, {
        getData: function ($defer, params) {
          vm.content.page = params.url().page
          MailingCampaignService
            .get(vm.content)
            .$promise
            .then(function (data) {
              vm.campaigns = data.data;
              if (data.data) {
                $defer.resolve(data.data.data)
                params.total(data.data.total)
                vm.totalCampaigns = data.data.total
              } else {
                vm.campaignTable = false
                errorHandler(error, vm.labels.errorLoadFileList);
              }
            })
            .catch(function (error) {
              errorHandler(error, vm.labels.errorLoadCamps);
            });
        }
      })
    }

    function loadAllUploadedFiles () {
      vm.fileTable = new ngTableParams({
        page: 1,
        count: 25
      }, {
        getData: function ($defer, params) {
          vm.content.page = params.url().page
          MailingCampaignService
            .listUploadedFiles(vm.content)
            .$promise
            .then(function (data) {
              if (data.data) {
                $defer.resolve(data.data.data)
                params.total(data.data.total)
                vm.totalFiles = data.data.total
              } else {
                vm.fileTable = false
                errorHandler(error, vm.labels.errorLoadFileList);
              }
            })
            .catch(function (error) {
              errorHandler(error, vm.labels.errorLoadFileList);
            })
        }
      })
    }

    function loadCampaign () {
      MailingCampaignService
        .find({ id: $stateParams.id })
        .$promise
        .then(function (obj) {
          vm.campaign = obj.data;
          if (typeof vm.campaign.send_params !== 'undefined' && vm.campaign.send_params.length > 0) {
            var length_params = vm.campaign.send_params.length;

            for (var index = 0; index < length_params; index++) {
              if (typeof vm.campaign.send_params[index].test_character !== 'undefined' && parseInt(vm.campaign.send_params[index].test_character) > 0) {
                vm.campaign.send_params[index].specificCharType = '0';
                vm.campaign.send_params[index].specificCharFilter = vm.campaign.send_params[index].test_character;

                delete vm.campaign.send_params[index].test_character;
              }
            }
          }

          if (vm.campaign.send_waent_params && vm.campaign.send_waent_params[0].length == 0) {
            vm.campaign.send_waent_params = [{}];
          }

          if (vm.campaign.send_sms_params && vm.campaign.send_sms_params[0].length == 0) {
            vm.campaign.send_sms_params = [{}];
          }

          parseMessageEmail()
          loadFileConfigs()
          vm.getWaentSubChannels()
        })
        .catch(function (error) {
          errorHandler(error, vm.labels.errorLoadCamp);
          goToTheListing();
        });
    }

    function loadFileConfigs () {
      ImportedFilesService
        .getCampaignFields({ imported_file_id: vm.campaign.imported_files_id })
        .$promise
        .then(function (data) {
          vm.fields = data;
        })
        .catch(function (error) {
          errorHandler(error, vm.labels.errorLoadFieldInfo);
        });
    }

    function loadCompanyData () {
      CompanyService
        .find({ id: $rootScope.user_data.company_id })
        .$promise
        .then(function (data) {
          if (typeof data.metadata !== 'undefined') {
            data.metadata.map(function (obj) {
              if (typeof obj.key !== 'undefined') {
                if (obj.key == 'mailingcampaigns') {
                  vm.configs = JSON.parse(obj.value);
                }
              }
            });
          }

          if (typeof data.emails !== 'undefined') {
            vm.emailChannels = data.emails;
          }

          if (typeof data.sms !== 'undefined') {
            vm.smsChannels = data.sms;
          }

          if (typeof data.waents !== 'undefined') {
            vm.waentChannels = data.waents;
            chooseWaentChannel();
          }

          if (typeof data.sectors !== 'undefined') {
            vm.sectors = data.sectors;
          }
        })
        .catch(function (error) {
          errorHandler(error, vm.labels.errorLoadChannels);
        });
    }

    vm.download = function (name) {
      vm.loading = true;
      $http.get(apiUrl + '/mailing/viewfile', {
        params: {
          path: name
        }
      })
        .then(function ({ data, status, headers, config }) {
          var filename = headers('Mktzap-Filename') || 'mailingcampaign.csv';

          var anchor = angular.element('<a/>');
          anchor.css({ display: 'none' }); // Make sure it's not visible
          angular.element(document.body).append(anchor); // Attach to document

          anchor.attr({
            href: 'data:attachment/csv;charset=utf-8,' + encodeURI(data),
            target: '_self',
            download: filename
          })[0].click();

          anchor.remove(); // Clean it up afterwards

          vm.loading = false;
        }, function ({ data, status, headers, config }) {
          errorHandler(data, vm.labels.selectedFileNotFound);
        })
    };

    vm.uploadFiles = function (file, expirationDate) {
      if (file) {
        if (file.length) {
          var params = {};

          params.company_id = $stateParams.id;
          params.imported_files_id = vm.campaign.imported_files_id;
          file.upload = Upload.upload({
            url: apiUrl + '/mailing-upload',
            fields: params,
            file: file
          });

          file.upload.then(function (response) {
            loadAllUploadedFiles();
            successHandler(response, vm.labels.loadedFile);
            runCommand(response.data.inserted_id, expirationDate);
            closeImportModal();
          }, function (response) {
            if (response.status > 0) { var message = vm.labels.errorRequest; }
            if (response) {
              if (response.data) {
                if (response.data.message) { message = response.data.message; }
              }
            }
            FoundationApi.publish('main-notifications', { title: 'Erro!', content: message, autoclose: '3000', color: 'alert' });
          });
        }
      }
    };

    function runCommand (file_id, expirationDate) {
      MailingCampaignService
        .runProcess({
          file_id: file_id,
          imported_files_id: vm.campaign.imported_files_id,
          expirationDate: expirationDate
        })
        .$promise
        .then(function (data) {
          if (typeof data.success !== 'undefined') {
            if (data.success) {
              successHandler(data, vm.labels.processStarted);
              loadAllUploadedFiles();
            } else if (data.success == false) {
              errorHandler(data, vm.labels.errorProcessFiles);
            }
          }
        })
        .catch(function (error) {
          errorHandler(error, vm.labels.errorProcessFiles);
        });
    }

    function errorHandler (data, override_message) {
      var message = vm.labels.errorTryAgain;
      if (override_message) {
        message = override_message;
      } else {
        if (data.data && data.data.message) {
          message = data.data.message;
        }
      }
      notifSet.addNotification({ title: vm.labels.error, content: message, autoclose: '3000', color: 'alert' });
    }

    function successHandler (data, override_message) {
      var message = vm.labels.dataSaved;
      if (override_message) {
        message = override_message
      } else {
        if (data && data.data && data.data.message) {
          message = data.data.message;
        }
      }
      notifSet.addNotification({ title: vm.labels.success, content: message, autoclose: '3000', color: 'success' });
    }

    function sumTotalPercentOfsend_params (value) {
      var sum = 0;

      $.each(vm.campaign.send_params, function (index, obj) {
        if (obj.hasOwnProperty('imported_files_fields_id')) {
          if (obj.imported_files_fields_id == value) {
            sum += parseInt(obj.percent, 10);
          }
        }
      });

      return sum;
    }

    function onChangeSendParamPercent (paramObj) {
      var totalPercent = sumTotalPercentOfsend_params(paramObj.imported_files_fields_id);

      if (totalPercent < 100) {
        var newPercent = 100 - totalPercent;
        var newParamObj = {
          imported_files_fields_id: paramObj.imported_files_fields_id,
          test_condition: '',
          test_value: '',
          message: '',
          percent: newPercent,
          send_type: ''
        };
        addParam(newParamObj);
      }
    }

    function filterSpecificCharacter (groupIndex, index) {
      if (typeof vm.campaign.filters.groups[groupIndex].filters[index] !== 'undefined') {
        FoundationApi.publish('specificCharFilterModal_' + groupIndex + '_' + index, 'open');
      }
    }

    function minimizeSpecificCharFilter (groupIndex, index) {
      if (typeof vm.campaign.filters.groups[groupIndex].filters[index] !== 'undefined') {
        FoundationApi.publish('specificCharFilterModal_' + groupIndex + '_' + index, 'close');
      }
    }

    function filterParamSpecificCharacter (index) {
      if (typeof vm.campaign.send_params[index] !== 'undefined') {
        FoundationApi.publish('specificCharFilterParamModal_' + index, 'open');
      }
    }

    function minimizeSpecificCharFilterParam (index) {
      if (typeof vm.campaign.send_params[index] !== 'undefined') {
        FoundationApi.publish('specificCharFilterParamModal_' + index, 'close');
      }
    }

    function changeCampaignType (type) {
      if (type === 'active') {
        vm.campaign.is_preventivo = 0;
      }

      if (type === 'preventivo') {
        vm.campaign.active = 0;
      }
    }

    function loadCampaignTypes () {
      ImportedFilesService
        .loadCampaignTypes()
        .$promise
        .then(function (data) {
          vm.campaignTypes = data;
        })
        .catch(function (error) {
          errorHandler(error, vm.labels.errorLoadCampTypes);
        });
    }

    function changeSendType (sendType, option) {
      if (option) {
        return;
      }

      for (var i = 0; i < vm.campaign.send_params.length; i++) {
        if (vm.campaign.send_params[i].send_type !== 'undefined' && vm.campaign.send_params[i].send_type === sendType) {
          vm.campaign.send_params[i].send_type = null;
        }
      }
    }

    function chooseWaentChannel (isChanging = false) {
      if (isChanging) {
        resetWaentSubChannels()
      }
      if (!vm.campaign.send_waent_channel) {
        vm.default_sector_id = null
        return
      }

      for (var i = 0; i < vm.waentChannels.length; i++) {
        if (vm.waentChannels[i].id == vm.campaign.send_waent_channel) {
          vm.default_sector_id = vm.waentChannels[i].default_sector_id
        }
      }
      vm.getWaentSubChannels()
    }

    vm.getWaentSubChannels = function () {
      WaentService
        .getSubChannelsByChannelId({ channelId: vm.campaign.send_waent_channel })
        .$promise
        .then(function (data) {
          if (data.length) {
            vm.waentSubChannels = data[0].subChannels || []
          }
        })
        .catch(function (err) {
          NotificationService.errorHandler(err, 'Não foi possível carregar as subcontas.')
        })
    }

    function resetWaentSubChannels () {
      vm.waentSubChannels = {}
      if (vm.campaign.extra_params) {
        vm.campaign.extra_params.subAccountId = undefined
      }
    }

    function onCheckFaturas () {
      if (vm.campaign.hasOwnProperty('extra_params') &&
        vm.campaign.extra_params &&
        vm.campaign.extra_params.faturas) {
        vm.campaign.extra_params.ret = false;
        vm.campaign.extra_params.noChatbot = false;
      }
    }

    function setExpirationDate (campaign) {
      vm.hasExpirationDate = false
      MailingCampaignService
        .checkExpirationDate({ imported_files_id: campaign.imported_files_id })
        .$promise
        .then(function (data) {
          vm.hasExpirationDate = data.hasCampaignsWithExpirationDate
        })
        .catch(function (error) {
          console.log(error)
          vm.hasExpirationDate = false
        })
    }
  }
})();
